// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {

  production: false,
  serverUrl: 'https://qeg4wpkgnc.execute-api.us-east-2.amazonaws.com/dev',
  bucket: 'biodatav2-test-upload',
  userPool: {
    UserPoolId: 'us-east-2_iZNVKY2Ha',
    ClientId: '1e61smekoj56gav6rsgosfabk5',
    region: 'us-east-2'
  },
  identityPoolId: 'us-east-2:0e113a62-ba41-4cb7-85c0-6ffea27ce37c',
  buckets: {
    'us-east-2': 'biodatav2-test-upload'
  },
  modules: {
    key: 'analysisType',
    values: [
      {
        'name': 'qPCR',
        'desc': 'qPCR'
      }
    ]
  },
  version: 'version 2.0',
  defaultRegion: 'us-east-2',
  cognito: {
    identityPoolId: 'us-east-2:0e113a62-ba41-4cb7-85c0-6ffea27ce37c', // REQUIRED - Amazon Cognito Identity Pool ID
    region: 'us-east-2', // REQUIRED - Amazon Cognito Region
    userPoolId: 'us-east-2_iZNVKY2Ha', // OPTIONAL - Amazon Cognito User Pool ID
    userPoolWebClientId: '1e61smekoj56gav6rsgosfabk5', // OPTIONAL - Amazon Cognito Web Client ID
  },
  Storage: {
    AWSS3: {
      bucket: 'biodatav2-test-upload',
      region: 'us-east-2', // OPTIONAL -  Amazon service region
    }
  }
};
const awsconfig = {
  'aws_project_region': 'us-east-2',
  'aws_cognito_region': 'us-east-2',
  'aws_user_pools_id': 'us-east-2_iZNVKY2Ha',
  'aws_user_pools_web_client_id': '1e61smekoj56gav6rsgosfabk5',
  'aws_cognito_mfa_configuration': 'OPTIONAL',

};
export default awsconfig;


